var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative d-inline-block"},[_c('span',{staticClass:"tooltip-number badge bg-primary"},[_vm._v(_vm._s(_vm.numero))]),_c('span',{staticClass:"h4 ml-3 font-weight-bold"},[_vm._v(_vm._s(_vm.descripcion))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }